const API_URL = process.env.REACT_APP_API_URL || '';

async function apiFetch(path, options = {}) {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const res = await fetch(`${API_URL}${path}`, { ...options, headers });

  if (res.status === 401 || res.status === 403) {
    localStorage.removeItem('token');
    window.location.href = '/login';
    return;
  }

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Error en la petición');
  return data;
}

async function apiFetchForm(path, options = {}) {
  const token = localStorage.getItem('token');
  const headers = {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const res = await fetch(`${API_URL}${path}`, { ...options, headers });

  if (res.status === 401 || res.status === 403) {
    localStorage.removeItem('token');
    window.location.href = '/login';
    return;
  }

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Error en la petición');
  return data;
}

export const api = {
  login: (username, password) =>
    apiFetch('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ username, password }),
    }),

  me: () => apiFetch('/api/auth/me'),
  changePassword: (new_password) =>
    apiFetch('/api/auth/change-password', { method: 'POST', body: JSON.stringify({ new_password }) }),

  getUsers: () => apiFetch('/api/users'),

  createUser: (data) =>
    apiFetch('/api/users', { method: 'POST', body: JSON.stringify(data) }),

  updateUser: (id, data) =>
    apiFetch(`/api/users/${id}`, { method: 'PUT', body: JSON.stringify(data) }),

  deleteUser: (id) =>
    apiFetch(`/api/users/${id}`, { method: 'DELETE' }),

  getDrawStatus: (year) => apiFetch(`/api/draw/status?year=${year}`),
  performDraw: (year) => apiFetch('/api/draw', { method: 'POST', body: JSON.stringify({ year }) }),
  getMyResult: (year) => apiFetch(`/api/draw/my-result?year=${year}`),
  resetDraw: (year) => apiFetch(`/api/draw?year=${year}`, { method: 'DELETE' }),

  listLetters: (year) => apiFetch(`/api/letters?year=${year}`),
  getLetter: (userId, year) => apiFetch(`/api/letters/${userId}?year=${year}`),
  updateMyFreeText: (year, free_text) =>
    apiFetch(`/api/letters/mine?year=${year}`, { method: 'PUT', body: JSON.stringify({ free_text }) }),

  addMyItem: (year, description, photoFile, existingPhotoUrl) => {
    const form = new FormData();
    form.append('description', description);
    if (photoFile) form.append('photo', photoFile);
    else if (existingPhotoUrl) form.append('existing_photo_url', existingPhotoUrl);
    return apiFetchForm(`/api/letters/mine/items?year=${year}`, { method: 'POST', body: form });
  },
  updateMyItem: (itemId, description, photoFile) => {
    const form = new FormData();
    if (description !== undefined) form.append('description', description);
    if (photoFile) form.append('photo', photoFile);
    return apiFetchForm(`/api/letters/mine/items/${itemId}`, { method: 'PUT', body: form });
  },
  deleteMyItem: (itemId) => apiFetch(`/api/letters/mine/items/${itemId}`, { method: 'DELETE' }),

  reserveItem: (itemId) => apiFetch(`/api/letters/items/${itemId}/reserve`, { method: 'POST' }),
  unreserveItem: (itemId) => apiFetch(`/api/letters/items/${itemId}/reserve`, { method: 'DELETE' }),

  listInspirations: (userId) =>
    apiFetch(userId ? `/api/inspirations?user_id=${userId}` : '/api/inspirations'),
  addInspiration: (photoFile, description) => {
    const form = new FormData();
    form.append('photo', photoFile);
    if (description) form.append('description', description);
    return apiFetchForm('/api/inspirations', { method: 'POST', body: form });
  },
  deleteInspiration: (id) => apiFetch(`/api/inspirations/${id}`, { method: 'DELETE' }),

  listConversations: () => apiFetch('/api/messages/conversations'),
  getConversationWith: (userId) => apiFetch(`/api/messages/with/${userId}`),
  getAnonConversation: (relatedUserId) => apiFetch(`/api/messages/anon-about/${relatedUserId}`),
  sendMessage: (receiver_id, content) =>
    apiFetch('/api/messages', { method: 'POST', body: JSON.stringify({ receiver_id, content }) }),
  sendToSecretSanta: (target_user_id, content, year) =>
    apiFetch('/api/messages/to-secret-santa', { method: 'POST', body: JSON.stringify({ target_user_id, content, year }) }),
  replyAsSecretSanta: (related_user_id, content) =>
    apiFetch('/api/messages/anon-reply', { method: 'POST', body: JSON.stringify({ related_user_id, content }) }),
  getUnreadCount: () => apiFetch('/api/messages/unread-count'),
};
